import { HttpRequest, HttpHandlerFn, HttpEvent, HttpEventType } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { NotifyService } from '../services/notify.service';
import { StorageService } from '../services/storage.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const loaderService = inject(LoaderService);
  const notifyService = inject(NotifyService);
  const storageService = inject(StorageService);

  loaderService.show();

  let headers = req.headers.set('language', 'en');
  const token = storageService.getToken();
  if (token) {
    headers = headers.set('Authorization', `bearer ${token}`);
  }
  const changedReq = req.clone({ withCredentials: true, headers });

  return next(changedReq).pipe(
    tap({
      next: (event: HttpEvent<unknown>) => {
        if (event.type === HttpEventType.Response) {
          loaderService.hide();
        }
      },
      error: (errRes: any) => {
        if (errRes.error instanceof Blob) {
          errRes.error.text().then((text: string) => {
            try {
              const parsed = JSON.parse(text);
              notifyService.error(parsed.message || errRes.statusText);
            } catch {
              notifyService.error(errRes.statusText);
            }
            loaderService.hide();
          });
          return;
        }

        if (changedReq.responseType && changedReq.responseType === 'text') {
          errRes.error = JSON.parse(errRes.error);
        }

        let message = errRes.error.message || errRes.statusText;

        if (errRes.status === 403) {
          console.warn('The request has been made with wrong credentials');
          return;
        }

        if (
          errRes.status === 502 ||
          (errRes.status === 0 && errRes.message.indexOf('Http failure response') > -1)
        ) {
          message = 'Server is unavailable';
        }
        loaderService.hide();
        notifyService.error(message);
      }
    })
  );
}
